import type { IScope } from 'angular';

const compareTo: angular.IDirectiveFactory = () => ({
  require: 'ngModel',
  scope: {
    otherModelValue: '=compareTo',
  },
  link(scope: IScope & { otherModelValue: any }, element, attributes, ngModel) {
    ngModel.$validators.compareTo = (modelValue: any) =>
      modelValue === scope.otherModelValue;

    scope.$watch('otherModelValue', () => {
      ngModel.$validate();
    });
  },
});

export default compareTo;
